module.exports = __webpack_public_path__ + "img/양식.a8f023d4.png";